const TRACKING_ID_KEY = 'biancode_tracking_id';
const FORM_START_TIME_KEY = 'biancode_form_start_time';

const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getOrCreateTrackingId = () => {
  let trackingId = localStorage.getItem(TRACKING_ID_KEY);
  if (!trackingId) {
    trackingId = generateUUID();
    localStorage.setItem(TRACKING_ID_KEY, trackingId);
  }
  return trackingId;
};

export const newFormTrackingId = () => {
  const trackingId = generateUUID();
  localStorage.setItem(TRACKING_ID_KEY, trackingId);
  return trackingId;
};

export const getTrackingId = () => {
  return localStorage.getItem(TRACKING_ID_KEY);
};

export const markFormStartTime = () => {
  sessionStorage.setItem(FORM_START_TIME_KEY, Date.now().toString());
};

export const getFormStartTime = () => {
  const val = sessionStorage.getItem(FORM_START_TIME_KEY);
  return val ? parseInt(val, 10) : null;
};

export const getTimeOnFormSeconds = () => {
  const start = getFormStartTime();
  if (!start) return 0;
  return Math.round((Date.now() - start) / 1000);
};
